import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, } from "@nextui-org/react";
import { useAuth, useFirestore, useFirestoreCollectionData, useUser } from "reactfire";
import { collection, where, query, getDocs, onSnapshot, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { NewKnowledgeBase } from "./newKbase";

const KnowledgeBases = () => {
    const navigate = useNavigate();
    const firestore = useFirestore();
    const auth = useAuth();

    const [kbases, setKbases] = useState<any>();

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });


    useEffect(() => {
        const fetchData = async () => {

            if (auth.currentUser) {
                const q = query(collection(firestore, "kbases"), where("createdBy", "==", auth.currentUser?.uid), orderBy('lastUpdated', 'desc'));

                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const docs: Array<any> = [];
                    querySnapshot.forEach((doc) => {
                        docs.push({ ...doc.data(), id: doc.id });
                    });
                    setKbases(docs);
                });
            }
        }
        fetchData();
    }, []);

    return (
        <>
            <div className="flex justify-between">
                <div className="text-2xl font-bold">Knolwedge Bases</div>
                <NewKnowledgeBase />
            </div>
            <br></br>
            <Table
                aria-label="Knowledge Bases"
                selectionMode="single"
            >
                <TableHeader>
                    <TableColumn>Name</TableColumn>
                    <TableColumn>Description</TableColumn>
                    <TableColumn>Created By</TableColumn>
                    <TableColumn>Last Updated</TableColumn>
                </TableHeader>
                <TableBody
                    emptyContent={"No rows to display"}>
                    {kbases?.map((kbase: any) => (
                        //TODO: paginated table 

                        <TableRow key={kbase.id} onClick={() => navigate(`/kbases/${kbase.id}`)}>
                            <TableCell>{kbase.name}</TableCell>
                            <TableCell>{kbase.description}</TableCell>
                            <TableCell>{kbase.createdByName}</TableCell>
                            <TableCell>{dateFormatter.format(new Date(kbase.lastUpdated))}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}


export default KnowledgeBases; 